import { combineReducers } from '@reduxjs/toolkit'

import { customisationSlice } from '@/redux/customisation/slice'
import { menuSlice } from '@/redux/menu/slice'
import { metaSlice } from '@/redux/meta/slice'
import { orderSlice } from '@/redux/order/slice'
import { storeItemAvailabilitySlice } from '@/redux/storeItemAvailability/slice'
import { storesSlice } from '@/redux/stores/slice'
import { instagramApi } from '@/services/instagram'
import { localApi } from '@/services/local'
import { omsApi } from '@/services/oms'
import { promotionSlice } from './promotion/slice'
import { checkoutSlice } from '@/redux/checkout/slice'
import { invoiceSlice } from '@/redux/invoice/slice'
import { thankyouSlice } from '@/redux/thankyou/slice'

const rootReducer = combineReducers({
  [omsApi.reducerPath]: omsApi.reducer,
  [metaSlice.name]: metaSlice.reducer,
  [orderSlice.name]: orderSlice.reducer,
  [storesSlice.name]: storesSlice.reducer,
  [storeItemAvailabilitySlice.name]: storeItemAvailabilitySlice.reducer,
  [customisationSlice.name]: customisationSlice.reducer,
  [localApi.reducerPath]: localApi.reducer,
  [menuSlice.name]: menuSlice.reducer,
  [instagramApi.reducerPath]: instagramApi.reducer,
  [promotionSlice.name]: promotionSlice.reducer,
  [checkoutSlice.name]: checkoutSlice.reducer,
  [invoiceSlice.name]: invoiceSlice.reducer,
  [thankyouSlice.name]: thankyouSlice.reducer,
})

export default rootReducer
